// src/context/LanguageContext.js
import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const translations = {
  ar: {
    // Nav
    home: "الرئيسية",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    dashboard: "لوحة التحكم",
    // Home
    heroTitle: "هل طفلك يعاني من ADHD؟",
    heroSubtitle: "نظم هي منصتك لدعم أطفال اضطراب فرط الحركة وتشتت الانتباه — اختبار مجاني، استشارات متخصصة، ودعم مستمر.",
    startQuiz: "ابدأ الاختبار المجاني",
    learnMore: "اعرف أكثر",
    // Quiz
    quizTitle: "اختبار ADHD",
    quizSubtitle: "أجب عن الأسئلة التالية بصدق للحصول على نتيجة دقيقة",
    next: "التالي",
    prev: "السابق",
    submit: "احسب النتيجة",
    question: "سؤال",
    of: "من",
    // Quiz options
    never: "أبداً",
    rarely: "نادراً",
    sometimes: "أحياناً",
    often: "غالباً",
    veryOften: "دائماً",
    // Result
    resultTitle: "نتيجة الاختبار",
    highRisk: "احتمالية مرتفعة لـ ADHD",
    moderateRisk: "احتمالية متوسطة",
    lowRisk: "احتمالية منخفضة",
    resultHigh: "بناءً على إجاباتك، يُشير الاختبار إلى احتمالية مرتفعة لوجود ADHD. نوصي بالتواصل مع متخصص.",
    resultModerate: "تشير النتائج إلى بعض العلامات التي تستوجب المتابعة مع متخصص.",
    resultLow: "لا تظهر النتائج علامات مقلقة، لكن إذا استمر قلقك يمكنك التواصل معنا.",
    paidConsult: "معاينة طبية مدفوعة",
    freeConsult: "استشارة نفسية مجانية",
    paidDesc: "تمارين وخطة علاجية مخصصة عبر محادثة مباشرة مع طبيب",
    freeDesc: "استشارة عامة مع متخصص نفسي",
    perMonth: "/ شهر",
    sar: "ر.س",
    // Auth
    emailLabel: "البريد الإلكتروني",
    passwordLabel: "كلمة المرور",
    nameLabel: "الاسم الكامل",
    childAgeLabel: "عمر الطفل",
    loginBtn: "دخول",
    registerBtn: "تسجيل",
    noAccount: "ليس لديك حساب؟",
    hasAccount: "لديك حساب بالفعل؟",
    // Payment
    paymentTitle: "الاشتراك في الخدمة المدفوعة",
    ibanLabel: "رقم الآيبان للتحويل",
    uploadReceipt: "رفع إيصال التحويل",
    uploadHint: "ارفع صورة أو PDF لإيصال التحويل البنكي",
    pendingStatus: "قيد المراجعة",
    activeStatus: "نشط",
    pendingMsg: "تم استلام إيصالك وسيتم مراجعته خلال ٢٤ ساعة",
    // Chat
    typeMessage: "اكتب رسالتك...",
    send: "إرسال",
    chatTitle: "المحادثة",
    noMessages: "لا توجد رسائل بعد",
    // Doctor
    doctorDashboard: "لوحة الطبيب",
    totalUsers: "إجمالي المستخدمين",
    paidUsers: "مستخدمون مدفوعون",
    freeUsers: "مستخدمون مجانيون",
    pendingApprovals: "بانتظار الموافقة",
    approve: "موافقة",
    reject: "رفض",
    viewProfile: "عرض الملف",
    // Categories
    schoolConsult: "استشارات مدرسية",
    parentingConsult: "تربية الأبناء",
    familyConsult: "مشكلات أسرية",
    other: "أخرى",
    selectCategory: "اختر نوع الاستشارة",
    // Misc
    loading: "جار التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    notifications: "الإشعارات",
    noNotifications: "لا توجد إشعارات",
    markRead: "تعيين كمقروء",
    years: "سنوات",
    welcomeBack: "مرحباً بعودتك",
    profile: "الملف الشخصي",
    messages: "الرسائل",
    patients: "المرضى",
    stats: "الإحصائيات",
    groupChat: "مجموعة الأطباء",
    // Admin Dashboard
    adminDashboard: "لوحة الإدارة",
    manageDoctors: "إدارة الأطباء",
    addDoctor: "إضافة طبيب",
    expirationAlerts: "تنبيهات الانتهاء",
    doctorName: "اسم الطبيب",
    doctorEmail: "البريد الإلكتروني",
    doctorPhone: "رقم الهاتف",
    doctorPassword: "كلمة المرور",
    accountDuration: "مدة الحساب",
    durationValue: "القيمة",
    durationUnit: "الوحدة",
    days: "أيام",
    weeks: "أسابيع",
    months: "أشهر",
    years: "سنوات",
    permanent: "دائم",
    createDoctor: "إنشاء حساب الطبيب",
    expiresAt: "تاريخ الانتهاء",
    lastLogin: "آخر دخول",
    accountStatus: "حالة الحساب",
    active: "نشط",
    suspended: "معلق",
    expired: "منتهي",
    suspend: "تعليق",
    activate: "تفعيل",
    extendDuration: "تمديد المدة",
    extend: "تمديد",
    neverLoggedIn: "لم يسجل الدخول بعد",
    permanentAccount: "حساب دائم",
    doctorCreatedSuccess: "تم إنشاء حساب الطبيب بنجاح",
    doctorCreatedError: "حدث خطأ أثناء إنشاء الحساب",
    expiringIn: "ينتهي خلال",
    day: "يوم",
    noDoctors: "لا يوجد أطباء",
    noAlerts: "لا توجد تنبيهات",
    confirmSuspend: "هل أنت متأكد من تعليق هذا الحساب؟",
    totalDoctors: "إجمالي الأطباء",
    activeDoctors: "أطباء نشطون",
    suspendedDoctors: "أطباء معلقون",
    expiringDoctors: "أطباء قارب انتهاء حسابهم",
  },
  en: {
    home: "Home",
    login: "Login",
    register: "Register",
    logout: "Logout",
    dashboard: "Dashboard",
    heroTitle: "Is your child struggling with ADHD?",
    heroSubtitle: "Nodom is your platform for ADHD support — free assessment, specialist consultations, and ongoing care.",
    startQuiz: "Start Free Assessment",
    learnMore: "Learn More",
    quizTitle: "ADHD Assessment",
    quizSubtitle: "Answer the following questions honestly for an accurate result",
    next: "Next",
    prev: "Back",
    submit: "Get Results",
    question: "Question",
    of: "of",
    never: "Never",
    rarely: "Rarely",
    sometimes: "Sometimes",
    often: "Often",
    veryOften: "Very Often",
    resultTitle: "Assessment Result",
    highRisk: "High ADHD Likelihood",
    moderateRisk: "Moderate Likelihood",
    lowRisk: "Low Likelihood",
    resultHigh: "Based on your answers, the assessment indicates a high likelihood of ADHD. We recommend consulting a specialist.",
    resultModerate: "Results show some signs that warrant follow-up with a specialist.",
    resultLow: "Results don't show concerning signs, but feel free to reach out if you remain concerned.",
    paidConsult: "Paid Medical Consult",
    freeConsult: "Free Psychological Advice",
    paidDesc: "Personalized exercises and treatment plan via direct doctor chat",
    freeDesc: "General consultation with a psychological specialist",
    perMonth: " / month",
    sar: "SAR",
    emailLabel: "Email Address",
    passwordLabel: "Password",
    nameLabel: "Full Name",
    childAgeLabel: "Child's Age",
    loginBtn: "Login",
    registerBtn: "Register",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    paymentTitle: "Subscribe to Paid Service",
    ibanLabel: "IBAN for Transfer",
    uploadReceipt: "Upload Transfer Receipt",
    uploadHint: "Upload an image or PDF of your bank transfer receipt",
    pendingStatus: "Pending Review",
    activeStatus: "Active",
    pendingMsg: "Your receipt has been received and will be reviewed within 24 hours",
    typeMessage: "Type your message...",
    send: "Send",
    chatTitle: "Chat",
    noMessages: "No messages yet",
    doctorDashboard: "Doctor Dashboard",
    totalUsers: "Total Users",
    paidUsers: "Paid Users",
    freeUsers: "Free Users",
    pendingApprovals: "Pending Approvals",
    approve: "Approve",
    reject: "Reject",
    viewProfile: "View Profile",
    schoolConsult: "School Consultations",
    parentingConsult: "Parenting",
    familyConsult: "Family Issues",
    other: "Other",
    selectCategory: "Select Consultation Type",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    notifications: "Notifications",
    noNotifications: "No notifications",
    markRead: "Mark as read",
    years: "years",
    welcomeBack: "Welcome back",
    profile: "Profile",
    messages: "Messages",
    patients: "Patients",
    stats: "Statistics",
    groupChat: "Doctor Group",
    // Admin Dashboard
    adminDashboard: "Admin Dashboard",
    manageDoctors: "Manage Doctors",
    addDoctor: "Add Doctor",
    expirationAlerts: "Expiration Alerts",
    doctorName: "Doctor Name",
    doctorEmail: "Email",
    doctorPhone: "Phone Number",
    doctorPassword: "Password",
    accountDuration: "Account Duration",
    durationValue: "Value",
    durationUnit: "Unit",
    days: "Days",
    weeks: "Weeks",
    months: "Months",
    years: "Years",
    permanent: "Permanent",
    createDoctor: "Create Doctor Account",
    expiresAt: "Expires At",
    lastLogin: "Last Login",
    accountStatus: "Account Status",
    active: "Active",
    suspended: "Suspended",
    expired: "Expired",
    suspend: "Suspend",
    activate: "Activate",
    extendDuration: "Extend Duration",
    extend: "Extend",
    neverLoggedIn: "Never logged in",
    permanentAccount: "Permanent Account",
    doctorCreatedSuccess: "Doctor account created successfully",
    doctorCreatedError: "Error creating doctor account",
    expiringIn: "Expiring in",
    day: "day",
    noDoctors: "No doctors",
    noAlerts: "No alerts",
    confirmSuspend: "Are you sure you want to suspend this account?",
    totalDoctors: "Total Doctors",
    activeDoctors: "Active Doctors",
    suspendedDoctors: "Suspended Doctors",
    expiringDoctors: "Expiring Soon",
  }
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nodom_lang") || "ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.classList.toggle("lang-en", lang === "en");
    localStorage.setItem("nodom_lang", lang);
  }, [lang]);

  const t = (key) => translations[lang][key] || translations["ar"][key] || key;
  const toggleLang = () => setLang(l => l === "ar" ? "en" : "ar");

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t, isRTL: lang === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
